import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useEffect, useState, useRef } from 'react';
import ResendActivationLink from './ResendActivation';

export default function ActivateUserPage() {
    const { uid, token } = useParams();
    const [status, setStatus] = useState("Activating...");
    const [error, setError] = useState(null);
    const hasActivated = useRef(false);
    const BASE_URL = process.env.REACT_APP_AUTH_URL;
    
    useEffect(() => {
      if (hasActivated.current) return; // prevent reruns
      hasActivated.current = true;
      console.log('UID:', uid, 'Token:', token); // Debug log
      if (uid && token) {
        console.log('Making activation request...'); // Debug log
        axios.post(`${BASE_URL}/auth/users/activation/`, { uid, token })
        .then(res => {
            setStatus("Your account has been successfully activated. Please login.");
          })
        .catch(err => {
          console.log(err)
          if (err.response && err.response?.data ) {
            const edata = err.response?.data
            if (edata.detail?.includes("Stale token")) {
                setError("⚠️ Your account is already activated. You can log in.") 
            } else if (edata.token?.[0]?.includes("Invalid token")) { // The response data from the server // Status code (e.g., 400, 404, 500)
                setError(`⚠️ Activation Failed - Your link has expired. Press the Resend Activation Link below to receive a fresh link in your inbox.`) 
            } else if (edata?.uid?.[0]?.includes("Invalid value")) {
                setError("⚠️ Activation Failed - Invalid activation link.");
            } else {
              setError(`⚠️ Server Response - ${err.message}`)
            }
          } else if (err.request) { // Request was made, but no response was received
            setError(`⚠️ Request Error - ${err.request}`); // The request made, containing data and headers
          } else {
            setError(`⚠️ Other Error - ${err.message}`); 
          }
        });
      }
    }, [uid, token]);
    console.log(error)
    console.log(status)
    return (
        <div className="text-secondary-900 text-center mt-10 w-full h-auto">
            {error ? <ResendActivationLink resendLink={error}/> : (<p>{status}</p>)}
        </div>
    );
}
